var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGbengFlag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 19,
    rx: 1.5,
    fill: "white",
    stroke: "#D5D6D8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 1,
    width: 3,
    height: 18,
    fill: "#D71F2A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 8.5,
    width: 3,
    height: 24,
    transform: "rotate(90 25 8.5)",
    fill: "#D71F2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGbengFlag);
export default __webpack_public_path__ + "static/media/gbeng-flag.86871cba7f15dae1789b9ea1e3848033.svg";
export { ForwardRef as ReactComponent };